const projects = [
  {
    id: 1,
    url: "https://yuvi.co.in/",
    slug: "yuvi-portfolio",
    title: "Yuvi.co.in",
    description: "A personal portfolio and business website for Yuvi.",
    breadcrumb: [
      { name: "Home", url: "/" },
      { name: "Projects", url: "/projects" },
      { name: "Yuvi.co.in", url: "/projects/yuvi-portfolio" }
    ],
    category: ["Portfolio", "Business Website"],
    approxBudget: "₹30,000 - ₹50,000",
    details: {
      client: "Yuvi",
      type: "Portfolio/Business Website",
      status: "Live",
      technologies: ["HTML", "CSS", "JavaScript"],
      briefTechStack: "Static HTML/CSS/JS hosted on Netlify",
      timeline: "3 weeks"
    },
    features: ["Responsive design", "Contact form", "Gallery"],
    pros: ["Lightweight", "SEO friendly", "Fast-loading"],
    cons: ["Static site, no CMS"],
    gallery: ["/images/yuvi/home.png"],
    keyResults: ["Increased inquiries by 40%"],
    timelineForCompletion: { start: "", end: "", duration: "" },
    metrics: {},
    testimonial: {},
    tags: ["Portfolio", "Business Website"],
    seo: {
      metaTitle: "Yuvi.co.in - Portfolio Website Development",
      metaDescription: "Case study: Yuvi.co.in portfolio/business website.",
      keywords: ["portfolio", "business site"],
      ogImage: "/images/yuvi/cover.png"
    }
  },
  {
    id: 2,
    url: "https://testdriive.com/carbuyingsecrets/",
    slug: "car-buying-secrets",
    title: "Car Buying Secrets",
    description: "A landing page for car buying secrets guide.",
    breadcrumb: [
      { name: "Home", url: "/" },
      { name: "Projects", url: "/projects" },
      { name: "Car Buying Secrets", url: "/projects/car-buying-secrets" }
    ],
    category: ["Landing Page", "Automotive"],
    approxBudget: "",
    details: {
      client: "TestDriive",
      type: "Landing Page",
      status: "Live",
      technologies: ["React", "TailwindCSS"],
      briefTechStack: "",
      timeline: ""
    },
    features: [],
    pros: [],
    cons: [],
    gallery: [],
    keyResults: [],
    timelineForCompletion: {},
    metrics: {},
    testimonial: {},
    tags: [],
    seo: {
      metaTitle: "Car Buying Secrets - TestDriive",
      metaDescription: "",
      keywords: [],
      ogImage: ""
    }
  },
  {
    id: 3,
    url: "https://happybhutantravel.com/",
    slug: "happy-bhutan-travel",
    title: "Happy Bhutan Travel",
    description: "Travel agency website for Bhutan tours.",
    breadcrumb: [
      { name: "Home", url: "/" },
      { name: "Projects", url: "/projects" },
      { name: "Happy Bhutan Travel", url: "/projects/happy-bhutan-travel" }
    ],
    category: ["Travel", "Tourism"],
    approxBudget: "",
    details: {
      client: "Happy Bhutan Travel",
      type: "Travel Website",
      status: "Live",
      technologies: [],
      briefTechStack: "",
      timeline: ""
    },
    features: [],
    pros: [],
    cons: [],
    gallery: [],
    keyResults: [],
    timelineForCompletion: {},
    metrics: {},
    testimonial: {},
    tags: [],
    seo: {
      metaTitle: "Happy Bhutan Travel - Travel Agency Website",
      metaDescription: "",
      keywords: [],
      ogImage: ""
    }
  },
  {
    id: 4,
    url: "https://aeravision.com/",
    slug: "aeravision",
    title: "Aeravision",
    description: "Corporate website for Aeravision.",
    breadcrumb: [
      { name: "Home", url: "/" },
      { name: "Projects", url: "/projects" },
      { name: "Aeravision", url: "/projects/aeravision" }
    ],
    category: ["Corporate"],
    approxBudget: "",
    details: {
      client: "Aeravision",
      type: "Corporate Website",
      status: "Live",
      technologies: [],
      briefTechStack: "",
      timeline: ""
    },
    features: [],
    pros: [],
    cons: [],
    gallery: [],
    keyResults: [],
    timelineForCompletion: {},
    metrics: {},
    testimonial: {},
    tags: [],
    seo: {
      metaTitle: "Aeravision - Corporate Website",
      metaDescription: "",
      keywords: [],
      ogImage: ""
    }
  },
  {
    id: 5,
    url: "https://isalis.org/",
    slug: "isalis",
    title: "Isalis.org",
    description: "Non-profit organization website.",
    breadcrumb: [
      { name: "Home", url: "/" },
      { name: "Projects", url: "/projects" },
      { name: "Isalis.org", url: "/projects/isalis" }
    ],
    category: ["Non-Profit"],
    approxBudget: "",
    details: { client: "Isalis", type: "Non-Profit Website", status: "Live", technologies: [], briefTechStack: "", timeline: "" },
    features: [],
    pros: [],
    cons: [],
    gallery: [],
    keyResults: [],
    timelineForCompletion: {},
    metrics: {},
    testimonial: {},
    tags: [],
    seo: { metaTitle: "Isalis.org - Non Profit Website", metaDescription: "", keywords: [], ogImage: "" }
  },

  // Continue similarly for each:
  // https://www.wespainclinic.com/
  // https://silverbellcity.com/
  // https://ebonyjp.com/
  // https://lixam-ug.de
  // https://newwork.com
  // https://asiantms.com/
  // www.akkcrusier.com
  // www.taxijee.in
  // www.akkweddingplanner.com
  // https://paradisecar.in/
  // https://avishreehospitality.com/
  // https://islamicalendar.in/
];
export default projects;